import { AVATAR_COLOR_MAP } from "~/designSystem/components/Avatar/constants";
import { type AvatarColor } from "~/designSystem/components/Avatar/interfaces";

export const isValidAvatarColor = (color?: string): color is AvatarColor => {
  return color ? Object.hasOwn(AVATAR_COLOR_MAP, color) : false;
};
